import React, { useState, useEffect, useContext } from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import { ConfigContext } from '../../Context/ConfigContext';

const AccountDetails = () => {
    const { apiURL, apiHeaderJson, customer_id } = useContext(ConfigContext);

    // Individual states for form fields
    const [firstName, setFirstName] = useState('');
    const [displayName, setDisplayName] = useState('');
    const [email, setEmail] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [currPassword, setCurrPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('');
    const [apiPassword, setApiPasswors] = useState("")

    // Individual states for validation errors
    const [firstNameError, setFirstNameError] = useState('');
    const [displayNameError, setDisplayNameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [newPasswordError, setNewPasswordError] = useState('');
    const [currPasswordError, setCurrPasswordError] = useState('');
    const [confirmPasswordError, setConfirmPasswordError] = useState('');

    const validateForm = () => {
        let isValid = true;

        if (!firstName.trim()) {
            setFirstNameError("First Name is required");
            isValid = false;
        } else {
            setFirstNameError('');
        }

        if (!displayName.trim()) {
            setDisplayNameError("Display Name is required");
            isValid = false;
        } else {
            setDisplayNameError('');
        }

        if (!email.trim()) {
            setEmailError("Email Address is required");
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            setEmailError("Enter a valid email address");
            isValid = false;
        } else {
            setEmailError('');
        }

        if (currPassword.trim()) {
            if (currPassword !== apiPassword) {
                setCurrPasswordError('Current Password does not match');
                isValid = false;
            } else {
                setCurrPasswordError('');
            }
        } else {
            setCurrPasswordError(''); // Allow submission if current password is empty
        }


        if (currPassword.trim()) {
            if (!newPassword.trim()) {
                setNewPasswordError("New password is required");
                isValid = false;
            }
            else if (newPassword.length < 6) {
                setNewPasswordError("Password must be at least 6 characters");
                isValid = false;
            }
            else {
                setNewPasswordError('');
            }
        } else {
            if (newPassword.trim() && newPassword.length < 6) {
                setNewPasswordError("Password must be at least 6 characters");
                isValid = false;
            } else {
                setNewPasswordError('');
            }
        }

        if (newPassword != confirmPassword) {
            setConfirmPasswordError("Passwords do not match");
            isValid = false;
        }

        else {
            setConfirmPasswordError('');
        }

        return isValid;
    };

    const resetForm = () => {
        setCurrPassword("");
        setNewPassword("");
        setConfirmPassword("")
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const Body = {
            customer_name: firstName,
            customer_email: email,
            customer_password: newPassword,
            customer_id
        }
        try {
            const headers = apiHeaderJson;
            if (!validateForm()) return
            const response = await axios.post(`${apiURL}Customers/UpdateCustomer`, Body, { headers })

            const { success, message } = response.data;

            Swal.fire({
                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                text: message,
                icon: success ? "success" : "error",
                timer: 2000,
                timerProgressBar: true,
                showConfirmButton: false,
            });

            if (success) {
                resetForm();
            }
        } catch (error) {
            console.log(error);

        }
    };

    const GetInfo = async () => {
        try {
            const response = await axios.get(`${apiURL}Customers/GetCustomerInfo`, { headers: apiHeaderJson });
            if (response.data.success) {
                setFirstName(response.data.data[0]?.customer_name || '');
                setEmail(response.data.data[0]?.customer_email || '');
                setDisplayName(response.data.data[0]?.customer_name || '');
                setApiPasswors(response.data.data[0]?.customer_password)
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        GetInfo();
    }, [customer_id]);

    return (
        <div className="card">
            <div className="card-header">
                <h5>Account Details</h5>
            </div>
            <div className="card-body">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        {/** First Name **/}
                        <div className="form-group col-md-6">
                            <label> Name <span className="required">*</span></label>
                            <input className="form-control" type="text" placeholder="Enter Your First Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                            {firstNameError && <span className="text-danger">{firstNameError}</span>}
                        </div>
                        {/** Display Name **/}
                        <div className="form-group col-md-6">
                            <label>Display Name <span className="required">*</span></label>
                            <input className="form-control" type="text" placeholder="Enter Your Display Name" value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
                            {displayNameError && <span className="text-danger">{displayNameError}</span>}
                        </div>

                        {/** Email Address **/}
                        <div className="form-group col-md-12">
                            <label>Email Address <span className="required">*</span></label>
                            <input className="form-control" type="email" placeholder="Enter Your Email Address" value={email} onChange={(e) => setEmail(e.target.value)} />
                            {emailError && <span className="text-danger">{emailError}</span>}
                        </div>

                        {/** Current Password **/}
                        <div className="form-group col-md-6">
                            <label>Current Password <span className="required">*</span></label>
                            <input className="form-control" type="password" placeholder="Enter Current Password" value={currPassword} onChange={(e) => setCurrPassword(e.target.value)} />
                            {currPasswordError && <span className="text-danger">{currPasswordError}</span>}
                        </div>
                        {/** New Password **/}

                        <div className="form-group col-md-6">
                            <label>New Password <span className="required">*</span></label>
                            <input className="form-control" type="password" placeholder="Enter New Password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                            {newPasswordError && <span className="text-danger">{newPasswordError}</span>}
                        </div>

                        {/** Confirm Password **/}
                        <div className="form-group col-md-12">
                            <label>Confirm Password <span className="required">*</span></label>
                            <input className="form-control" type="password" placeholder="Enter Confirm Password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                            {confirmPasswordError && <span className="text-danger">{confirmPasswordError}</span>}
                        </div>

                        {/** Submit Button **/}
                        <div className="col-md-12">
                            <button type="submit" className="btn btn-fill-out submit font-weight-bold">Save Change</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AccountDetails;